(() => {
  const root = document.documentElement;
  const body = document.body;
  const moneyText = (value) => value || '';
  const savedHandles = () => {
    try {
      const value = JSON.parse(localStorage.getItem('monea:wishlist') || '[]');
      return new Set(Array.isArray(value) ? value : []);
    } catch (_error) {
      return new Set();
    }
  };

  const setScrollLock = () => {
    body.classList.toggle('is-scroll-locked', Boolean(document.querySelector('dialog[open], .m-filter-panel.is-open')));
  };

  const openDialog = (dialog, trigger) => {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    trigger?.setAttribute('aria-expanded', 'true');
    setScrollLock();
  };

  const closeDialog = (dialog, trigger) => {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    trigger?.setAttribute('aria-expanded', 'false');
    setScrollLock();
    trigger?.focus();
  };

  document.addEventListener('click', (event) => {
    const menuOpen = event.target.closest('[data-menu-open]');
    if (menuOpen) return openDialog(document.querySelector('[data-mobile-menu]'), menuOpen);

    const menuClose = event.target.closest('[data-menu-close]');
    if (menuClose) return closeDialog(menuClose.closest('dialog'), document.querySelector('[data-menu-open]'));

    const filterOpen = event.target.closest('[data-filter-open]');
    if (filterOpen) {
      const panel = document.querySelector('[data-filter-panel]');
      panel?.classList.add('is-open');
      filterOpen.setAttribute('aria-expanded', 'true');
      setScrollLock();
      panel?.querySelector('[data-filter-close]')?.focus();
      return;
    }

    const filterClose = event.target.closest('[data-filter-close]');
    if (filterClose) {
      const panel = filterClose.closest('[data-filter-panel]');
      panel?.classList.remove('is-open');
      const trigger = document.querySelector('[data-filter-open]');
      trigger?.setAttribute('aria-expanded', 'false');
      setScrollLock();
      trigger?.focus();
      return;
    }

    const openFilterPanel = document.querySelector('[data-filter-panel].is-open');
    if (openFilterPanel && !event.target.closest('[data-filter-panel]')) {
      openFilterPanel.classList.remove('is-open');
      const trigger = document.querySelector('[data-filter-open]');
      trigger?.setAttribute('aria-expanded', 'false');
      setScrollLock();
      return;
    }

    const quantityButton = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (quantityButton) {
      const input = quantityButton.closest('.m-quantity')?.querySelector('[data-quantity-input]');
      if (!input) return;
      const next = Number(input.value || 1) + (quantityButton.hasAttribute('data-quantity-plus') ? 1 : -1);
      input.value = Math.max(Number(input.min || 1), next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const thumb = event.target.closest('[data-media-target]');
    if (thumb) {
      const gallery = thumb.closest('[data-product-gallery]');
      gallery?.querySelectorAll('[data-media-target]').forEach((item) => {
        const active = item === thumb;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      gallery?.querySelectorAll('[data-media-slide]').forEach((slide) => {
        const active = slide.dataset.mediaSlide === thumb.dataset.mediaTarget;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      return;
    }

    const zoom = event.target.closest('[data-gallery-zoom]');
    if (zoom) {
      const section = zoom.closest('[data-product-section]');
      const active = section?.querySelector('.m-product-media.is-active');
      const lightbox = section?.querySelector('[data-media-lightbox]');
      const content = lightbox?.querySelector('[data-lightbox-content]');
      const image = active?.querySelector('img');
      if (!lightbox || !content || !image) return;
      content.replaceChildren(image.cloneNode(true));
      openDialog(lightbox, zoom);
      return;
    }

    const lightboxClose = event.target.closest('[data-lightbox-close]');
    if (lightboxClose) return closeDialog(lightboxClose.closest('dialog'), document.querySelector('[data-gallery-zoom]'));

    const wishlist = event.target.closest('[data-wishlist-button]');
    if (wishlist) {
      const handle = wishlist.dataset.productHandle;
      const saved = savedHandles();
      saved.has(handle) ? saved.delete(handle) : saved.add(handle);
      localStorage.setItem('monea:wishlist', JSON.stringify([...saved]));
      document.querySelectorAll(`[data-wishlist-button][data-product-handle="${CSS.escape(handle)}"]`).forEach((button) => {
        const active = saved.has(handle);
        const productName = button.getAttribute('aria-label').replace(/^(Запази|Премахни)\s+/, '');
        button.classList.toggle('is-saved', active);
        button.setAttribute('aria-pressed', String(active));
        button.setAttribute('aria-label', `${active ? 'Премахни' : 'Запази'} ${productName}`);
      });
    }
  });

  document.addEventListener('click', (event) => {
    const dialog = event.target.closest('dialog[open]');
    if (dialog && event.target === dialog) closeDialog(dialog, document.querySelector(dialog.matches('[data-mobile-menu]') ? '[data-menu-open]' : '[data-gallery-zoom]'));
  });

  document.addEventListener('cancel', (event) => {
    if (!event.target.matches('dialog')) return;
    requestAnimationFrame(setScrollLock);
    document.querySelector(event.target.matches('[data-mobile-menu]') ? '[data-menu-open]' : '[data-gallery-zoom]')?.setAttribute('aria-expanded', 'false');
  }, true);

  document.addEventListener('keydown', (event) => {
    const panel = document.querySelector('[data-filter-panel].is-open');
    if (!panel) return;
    if (event.key === 'Escape') {
      panel.classList.remove('is-open');
      const trigger = document.querySelector('[data-filter-open]');
      trigger?.setAttribute('aria-expanded', 'false');
      setScrollLock();
      trigger?.focus();
      return;
    }
    if (event.key === 'Tab') {
      const focusable = [...panel.querySelectorAll('button, [href], input, select, textarea, summary, [tabindex]:not([tabindex="-1"])')].filter((item) => !item.disabled && item.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-localization-select]')) event.target.form?.submit();
    if (event.target.matches('[data-auto-submit]')) event.target.form?.submit();

    const input = event.target.closest('[data-variant-input]');
    if (!input) return;
    const section = input.closest('[data-product-section]');
    const available = input.dataset.available === 'true';
    section.querySelector('[data-price-current]').textContent = moneyText(input.dataset.price);
    const compare = section.querySelector('[data-price-compare]');
    compare.textContent = moneyText(input.dataset.comparePrice);
    compare.hidden = !input.dataset.comparePrice;
    section.querySelector('[data-stock-text]').textContent = available ? (Number(input.dataset.inventory) > 0 && Number(input.dataset.inventory) <= 5 ? `${section.dataset.stockLow} ${input.dataset.inventory}` : section.dataset.stockAvailable) : section.dataset.stockUnavailable;
    section.querySelector('[data-product-stock]').classList.toggle('is-unavailable', !available);
    section.querySelector('[data-add-to-cart]').disabled = !available;
    section.querySelector('[data-add-to-cart-text]').textContent = available ? section.dataset.addLabel : section.dataset.soldLabel;
    section.querySelector('[data-variant-name]').textContent = input.nextElementSibling?.textContent.trim() || '';
    if (input.dataset.mediaId) section.querySelector(`[data-media-target="${CSS.escape(input.dataset.mediaId)}"]`)?.click();
    if (input.dataset.url && history.replaceState) history.replaceState({}, '', input.dataset.url);
  });

  const restoreWishlist = () => {
    const saved = savedHandles();
    document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
      const active = saved.has(button.dataset.productHandle);
      const productName = button.getAttribute('aria-label').replace(/^(Запази|Премахни)\s+/, '');
      button.classList.toggle('is-saved', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', `${active ? 'Премахни' : 'Запази'} ${productName}`);
    });
  };

  const reveal = () => {
    const items = document.querySelectorAll('.m-reveal:not(.is-revealed)');
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((item) => item.classList.add('is-revealed'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    items.forEach((item) => observer.observe(item));
  };

  const loadRecommendations = () => {
    document.querySelectorAll('product-recommendations[data-url]:not([data-loaded])').forEach((element) => {
      element.dataset.loaded = 'true';
      fetch(element.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const replacement = html.querySelector('product-recommendations');
          if (replacement?.innerHTML.trim()) element.innerHTML = replacement.innerHTML;
          restoreWishlist();
          reveal();
        })
        .catch(() => {});
    });
  };

  const init = () => { restoreWishlist(); reveal(); loadRecommendations(); };
  init();
  document.addEventListener('shopify:section:load', init);
  root.classList.add('m-ready');
})();
